/**
 * 拘束時間管理ページ用のスクリプト
 */
if (is_route('duty_hour.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        duty_hour_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.duty_hour_event_set = function () {


    /*---- 印刷ボタン押下時 ----*/

    // 一覧・詳細 印刷
    $(document).on('click', '[data-total-print],[data-detail-print]', function () {
        let type = 'total-print';
        if ($(this).is('[data-detail-print]')) {
            type = 'detail-print';
        }
        // 送信値を配列化
        let datas = [];
        let action = extend_url_query($(this).data(type));
        // BlobでPDFを別ウィンドウで表示
        _ajax.blob(action, datas, function (blob) {
            window.open(window.URL.createObjectURL(blob), '_blank');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });

}
